<template>
    <router-link :to="{name:to ?? 'Dashboard',params}" class="btn btn-outline-primary btn-xs" >
        <i class="bi bi-skip-backward-fill me-1"></i> {{ title ?? " Revenir au tableau de bord" }}
    </router-link>
</template>
<script>
export default {
    name:"AdminAction",
    props:{
        to:{
            type:String,
        },
        params:{
            type:Object,
            default(){
                return {};
            }
        },
        title:{
            type:String,
        }
    }
}
</script>